export const apiConstants = {
  cycles: '/cycles',
  cycleCurrent: '/cycle/current',
  cyclesData: '/cycle/data',
  cycle: '/cycle',
  menu: '/menu',
};
